import React from 'react';

export const OidcRoutesContext = React.createContext();
export const TextLibraryContext = React.createContext();
